import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { base_url } from "./AdminUsers";

const EditModal = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [formData, setFormData] = useState({
        attachment: null,
        previewUrl: ''
    });
    const [error, setError] = useState(null);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Fetch existing logo
    useEffect(() => {
        const fetchLogoData = async () => {
            const auth = localStorage.getItem("admin");
            try {
                setIsLoading(true);
                const response = await axios.get(
                    `${base_url}/api/webapi/fetchModal?id=${id}`, 
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `${auth}`,
                        },
                    }
                );

                if (response.data.success) {
                    const logoData = response.data.data.result[0];
                    setFormData(prev => ({
                        ...prev,
                        previewUrl: base_url + logoData.image 
                    }));
                } else {
                    throw new Error(response.data.message || "Failed to fetch modal data");
                }
            } catch (error) {
                console.error("Error fetching logo data:", error);
                setError("Error loading logo. Please try again.");
                toast.error("Error loading logo.");
                navigate("/admin/slider");
            } finally {
                setIsLoading(false);
            }
        };

        fetchLogoData();
    }, [id, navigate]);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            if (!mobile) setIsSidebarOpen(true);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (hasUnsavedChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [hasUnsavedChanges]);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const selectedFile = e.target.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData(prev => ({
                    ...prev,
                    attachment: selectedFile,
                    previewUrl: reader.result
                }));
            };
            reader.readAsDataURL(selectedFile);
            setHasUnsavedChanges(true);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.attachment) {
            toast.error("Please select a logo image to upload.");
            return;
        }

        setIsSubmitting(true);
        const formDataToSend = new FormData();
        formDataToSend.append('attachment', formData.attachment);
        formDataToSend.append('id', id);

        try {
            const auth = localStorage.getItem('admin');
            const response = await axios.post(
                `${base_url}/api/webapi/updateModal`,
                formDataToSend,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `${auth}`,
                    },
                }
            );

            if (response.data.success) {
                toast.success("Logo updated successfully");
                setHasUnsavedChanges(false);
                navigate("/admin/slider"); // ✅ Change this if needed
            } else {
                throw new Error(response.data.message || "Failed to update logo");
            }
        } catch (error) {
            console.error('Error updating logo:', error);
            toast.error('An error occurred. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger m-5">
                {error}
            </div>
        );
    }

    return (
        <div className="wrapper">
            {/* <AdminSidebar 
                isSidebarOpen={isSidebarOpen} 
                toggleSidebar={toggleSidebar} 
                isMobile={isMobile}
            />
            <AdminHeader 
                toggleSidebar={toggleSidebar} 
                isSidebarOpen={isSidebarOpen}
                isMobile={isMobile}
            /> */}

            <div className={`content-wrapper d-flex flex-column ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"}`}
                style={{ marginLeft: (!isMobile && isSidebarOpen) ? "" : "0", transition: "margin-left 0.3s ease" }}
            >
                <div className="container-fluid">
                    <h1 className="page-title"><i className="fa fa-edit"></i> Edit Logo</h1>
                    <div className="page-content mt-4 browse">
                        <div className="row">
                            <div className="col-md-12 oneonofftab">
                                <div className="panel panel-bordered p-3">
                                    <div className="panel-heading">
                                        <h3 className="panel-title">Update Modal image</h3>
                                    </div>
                                    <div className="panel-body">
                                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                                            <div className="form-group mb-3">
                                                <label htmlFor="attachment">Attachment</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="image/*"
                                                    id="attachment"
                                                    onChange={handleFileChange}
                                                />
                                                {formData.previewUrl && (
                                                    <div className="mt-2">
                                                        <p>Preview:</p>
                                                        <img
                                                            src={formData.previewUrl}
                                                            alt="Preview"
                                                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                                                            onError={(e) => { e.target.onerror = null; e.target.src = '/placeholder-image.jpg' }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="form-group mt-4">
                                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                                    {isSubmitting ? (
                                                        <>
                                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Updating...
                                                        </>
                                                    ) : "Update Logo"}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary ms-2"
                                                    onClick={() => navigate('/admin/slider')}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditModal;
